export const CONFIRMED_GET_BANKS = '[Bank Action] Confirmed Get Banks';
